import Vue from 'vue'
import {steps} from "./helpers";
const state = Vue.observable({
        loading: false,
        passed:[],
        currentStep: steps[0],//default first step
        steps: steps,
        summary:{
            address:{
                formatted:null,
                lat:null,
                lng:null
            }, //Address object
            panels:{ //Panels count and type
                type: null,
                amount:0
            },
            products:[],//Additional products
            roof:{ //Roof type and square
                type:0,
                size:0,
                material:''
            },
            snapshot:null,
        },
        invoice:{
            subtotal:0,
            total:0,
            savings:0,
            greenDiscount:0,
            panels:0,
            products:[],
        },
        form:{
            fname:'',
            lname:'',
            email:'',
            phone:'',
            address:'',
            zipcode:'',
            city:'',
            code:'',
            confirm:null,
            campaign:false,
        },
        place: null,
        polygon: null,
        isValid: false
    });

export default {
    storage:{
        state:state,
        showLoading(){
            state.loading = true;
        },
        hideLoading(){
            state.loading = false;
        },
        /*showMessage(msg){
            Vue.notify({
                group: 'notify',
                title: 'Success',
                position:['bottom'],
                text: msg,
                type: 'success',
            });
        },
        showError(msg,title='',status=''){
            Vue.notify({
                group: 'notify',
                title: 'Error' + '  ' + status ? status + ' ' + title : title,
                position:['bottom'],
                text: msg,
                type: 'error',
            });
        },*/

    },

    // eslint-disable-next-line no-unused-vars
    install(Vue, options = []) {
        Vue.prototype.$storage = this.storage
    }
}
